// store/photoTrackingSlice.js
import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    trackedIds: [] // Change this from Set to an array
};

const PhotoTrackingSlice = createSlice({
    name: 'photoTracking',
    initialState,
    reducers: {
        addTrackedId: (state, action) => {
            // Add to array instead of Set
            if (!state.trackedIds.includes(action.payload)) {
                state.trackedIds.push(action.payload);
            }
        },

    }
});
export const { addTrackedId, removeTrackedId, resetTrackedIds } = PhotoTrackingSlice.actions;
export default PhotoTrackingSlice;
